module.exports = __webpack_public_path__ + "img/jinqiu.8cde6250.png";